module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya/access/nagoya_point3_3-d7819aaebbe894c769a2a7392beccd05.jpg";